import type { Room } from "../../../interfaces/interfaces";

export default [
  {
    name: "E326",
    id: "fdedc9fe-0576-4f5f-a9b2-43cbd3f6ac7c",
  },
  {
    name: "E324",
    id: "a543d851-2fb1-4a5e-add8-38907e790cec",
  },
  {
    name: "E236",
    id: "2aad2b37-149d-470c-9202-fa8408d70a1c",
  },
  {
    name: "FE249",
    id: "b5b18f43-125a-4ec6-abfc-4ddeaab205db",
  },
  {
    name: "J206/Planck",
    id: "7b6cc053-3eae-4400-b287-ac32dd203544",
  },
  {
    name: "FB113",
    id: "c13b19f7-e540-4b6f-829f-160f30ba7d94",
  },
  {
    name: "Auger",
    id: "45e0769d-7b57-4af5-8605-5af818b13a9c",
  },
  {
    name: "Avogadros",
    id: "3ca83320-c39f-4400-b2c4-a92cc0552d21",
  },
  {
    name: "FE243",
    id: "f9d27357-2b86-4e61-b263-457d9f93a867",
  },
  {
    name: "FE245",
    id: "4d7196d2-9473-43de-9fbd-f09a5789544e",
  },
  {
    name: "FE241",
    id: "bf7fe2c4-b1d2-4132-a783-07ce2178eb11",
  },
  {
    name: "FE244",
    id: "348fd909-4eb7-45f0-a97c-32da19d1c1d6",
  },
  {
    name: "FE246",
    id: "984d01fb-dd73-4b6d-a694-c39a90f2a0e0",
  },
  {
    name: "FE242",
    id: "0eb7400d-13c4-493e-89e4-1cfc9af1684c",
  },
  {
    name: "Ingång 55",
    id: "8cf3003a-02da-4e92-9066-28175a192e66",
  },
  {
    name: "Ingång 57",
    id: "b241aad0-a80f-49e0-93e3-d224a91a40aa",
  },
] as Room[];
